import { useEffect, useRef, useState } from "react";

/**
 * Observa un elemento y activa su visibilidad al entrar en el viewport.
 *
 * @param {number} threshold - Porcentaje de visibilidad necesario para disparar.
 * @returns {[import("react").MutableRefObject<HTMLElement | null>, boolean]}
 */
const useScrollReveal = (threshold = 0.15) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold },
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, [threshold]);

  return [ref, visible];
};

export default useScrollReveal;
